/**
 * *********************************************************
 * CLIENT NAVLOG API HELPER
 * *********************************************************
 *
 * This file belongs on the React client side.
 *
 * It does not talk directly to Firebase.
 * It only sends requests to the server API routes.
 *
 * React Component
 *   -> navlogApi.js
 *      -> server API route
 *         -> navlogRepository.js
 *            -> Firebase
 *
 * this file supports full CRUD operations for navlogs.
 * It is used by NavlogSaveLoadControls.jsx, 
 * which provides the UI for saving, updating, and deleting navlogs.
 * *********************************************************
 */

const API_BASE = process.env.REACT_APP_API_BASE || "";

// ------------------------------------------------------------
// SAVE NEW NAVLOG
// ------------------------------------------------------------
export async function saveNavlog(payload) {
    console.log(
      "Saving navlog for airplane:",
      payload.airplaneId
    );
  const res = await fetch(
    `${API_BASE}/api/navlogs?tail=${encodeURIComponent(payload.airplaneId)}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    }
  );

  if (!res.ok) {
    throw new Error("Failed to save navlog");
  }

  return res.json();
}

// ------------------------------------------------------------
// LIST SAVED NAVLOGS
// ------------------------------------------------------------
export async function listNavlogs(airplaneId) {
  const res = await fetch(
    `${API_BASE}/api/navlogs?tail=${encodeURIComponent(airplaneId)}`);

  if (!res.ok) {
    throw new Error("Failed to load saved navlogs");
  }

  return res.json();
}

// ------------------------------------------------------------
// GET ONE SAVED NAVLOG
// ------------------------------------------------------------
export async function getNavlog({ airplaneId, navlogId }) {
  const res = await fetch(
    `${API_BASE}/api/navlogs?tail=${encodeURIComponent(
      airplaneId
    )}&id=${encodeURIComponent(navlogId)}`
  );

  if (!res.ok) {
    throw new Error("Failed to load navlog");
  }

  return res.json();
}

    // ------------------------------------------------------------
    // UPDATE EXISTING NAVLOG
    // ------------------------------------------------------------
    export async function updateNavlog(payload) {
      const res = await fetch(
        `${API_BASE}/api/navlogs?tail=${encodeURIComponent(
          payload.airplaneId
        )}&id=${encodeURIComponent(payload.navlogId)}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) {
        throw new Error("Failed to update navlog");
      }

      return res.json();
    }


    // ------------------------------------------------------------
    // DELETE NAVLOG
    // ------------------------------------------------------------
    export async function deleteNavlog({
      airplaneId,
      navlogId,
    }) {
      const res = await fetch(
        `${API_BASE}/api/navlogs?tail=${encodeURIComponent(
          airplaneId
        )}&id=${encodeURIComponent(navlogId)}`,
        {
          method: "DELETE",
        }
      );

      if (!res.ok) {
        throw new Error("Failed to delete navlog");
      }

      return true;
    }